import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IConfirmDialogData } from './confirm-dialog-data';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestsService } from '../shared/services/requests.service';
import { SnackbarService } from '../shared/services/snackbar.service';


@Component({
  selector: 'xp-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
    confirmForm: FormGroup;
    buttonType: string = 'ConfirmCancel';
    accountsStage = false;
    matterNo?: number;
    actionstepMatterUrl: string = '';
    actionstepBaseUrl: string = '';
    selectedBankAccountId: string = '';

    constructor(
        private fb: FormBuilder,
        private requestService: RequestsService,
        private snackbarService: SnackbarService,
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>, 
        @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData,
    ) {
        dialogRef.disableClose = true;

        if (this.data.buttonType != undefined) {
            this.buttonType = this.data.buttonType
        }

        this.confirmForm = this.fb.group({
            isTransactionReversed: ['']
        });

        this.matterNo = this.data.matterNo;
        this.selectedBankAccountId = this.data.selectedBankAccountId;

        const isRpa = this.data?.rpaStatus === true;
        const stageId = this.data?.currentStageId;

        this.accountsStage = this.data?.skipAccountsValidation ? isRpa : (stageId === 6 && isRpa) || (stageId === 4 && isRpa);
        if (this.accountsStage) {
            const control = this.confirmForm.get('isTransactionReversed');
            control?.setValidators([Validators.required]);
            control?.updateValueAndValidity();
        }
    }

    async ngOnInit() {
        this.actionstepBaseUrl = await this.requestService.getActionstepUrl();
        this.actionstepMatterUrl = `${this.actionstepBaseUrl}?action_id=${this.matterNo}&ac_account_id=${this.selectedBankAccountId}`;
    }

    onUrlCopied() {
        this.snackbarService.successSnackBar("URL copied to clipboard");
    }

    confirm() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
